/**
 * Folder UI meta — icon + color palettes shared by the picker, sidebar,
 * and hero banners. Icon stored as a string key on the folder record;
 * resolved here at render time.
 */
import {
  Folder, FolderOpen, BookOpen, Briefcase, Code2, Lightbulb,
  Users, Star, Shield, Award, Layers, Target, Box, GraduationCap,
  Rocket, HeartPulse, Megaphone, BarChart3, Compass, Wrench,
} from 'lucide-react';

export const FOLDER_ICONS = {
  folder: Folder,
  'folder-open': FolderOpen,
  book: BookOpen,
  briefcase: Briefcase,
  code: Code2,
  lightbulb: Lightbulb,
  users: Users,
  star: Star,
  shield: Shield,
  award: Award,
  layers: Layers,
  target: Target,
  box: Box,
  graduation: GraduationCap,
  rocket: Rocket,
  health: HeartPulse,
  megaphone: Megaphone,
  chart: BarChart3,
  compass: Compass,
  wrench: Wrench,
};

export const FOLDER_ICON_KEYS = Object.keys(FOLDER_ICONS);

export const FOLDER_COLORS = [
  { key: 'slate',   hex: '#64748B' },
  { key: 'blue',    hex: '#2563EB' },
  { key: 'indigo',  hex: '#4F46E5' },
  { key: 'violet',  hex: '#7C3AED' },
  { key: 'pink',    hex: '#DB2777' },
  { key: 'rose',    hex: '#E11D48' },
  { key: 'red',     hex: '#DC2626' },
  { key: 'orange',  hex: '#EA580C' },
  { key: 'amber',   hex: '#D97706' },
  { key: 'lime',    hex: '#65A30D' },
  { key: 'emerald', hex: '#059669' },
  { key: 'teal',    hex: '#0D9488' },
  { key: 'cyan',    hex: '#0891B2' },
  { key: 'sky',     hex: '#0284C7' },
];

export const FOLDER_COLOR_HEXES = FOLDER_COLORS.map(c => c.hex);

export function resolveIcon(icon) {
  return FOLDER_ICONS[icon] || FOLDER_ICONS.folder;
}

export function resolveColor(color) {
  if (!color) return '#64748B';
  // Accept either palette key or raw hex
  const match = FOLDER_COLORS.find(c => c.key === color || c.hex.toLowerCase() === color.toLowerCase());
  return match ? match.hex : color;
}

export const MAX_FOLDER_DEPTH = 2; // 0,1,2 → 3 levels per backend
